import { ShieldAlert, Truck } from "lucide-react";

export const FDA_DISCLAIMER =
  "These statements have not been evaluated by the Food and Drug Administration. These products are not intended to diagnose, treat, cure, or prevent any disease. For use only by adults 21 and older. Keep out of reach of children and pets. Do not use if pregnant or nursing.";

export const THCA_SHIPPING_RESTRICTION =
  "All products are federally compliant hemp containing less than 0.3% Delta-9 THC on a dry-weight basis in accordance with the 2018 Farm Bill. Due to varying state laws, we cannot ship THCA products to: Arkansas, Colorado, Hawaii, Idaho, Kansas, Minnesota, Montana, North Dakota, Oregon, Rhode Island, Utah, Vermont, and Washington. Laws change frequently — it is the buyer's responsibility to confirm the legality of these products in their state before ordering. Orders placed to restricted states may be cancelled and refunded.";

export const FdaDisclaimer = ({ className = "" }) => (
  <div
    data-testid="fda-disclaimer"
    className={`flex gap-2 text-xs leading-relaxed text-neutral-500 ${className}`}
  >
    <ShieldAlert className="mt-0.5 h-4 w-4 shrink-0 text-[#a06d34]" strokeWidth={1.5} />
    <p>
      <span className="font-semibold uppercase tracking-wide text-neutral-600">FDA Disclaimer:</span>{" "}
      {FDA_DISCLAIMER}
    </p>
  </div>
);

export const ShippingRestriction = ({ className = "" }) => (
  <div
    data-testid="thca-shipping-restriction"
    className={`flex gap-2 text-xs leading-relaxed text-neutral-500 ${className}`}
  >
    <Truck className="mt-0.5 h-4 w-4 shrink-0 text-[#a06d34]" strokeWidth={1.5} />
    <p>
      <span className="font-semibold uppercase tracking-wide text-neutral-600">THCA Shipping Restrictions:</span>{" "}
      {THCA_SHIPPING_RESTRICTION}
    </p>
  </div>
);
